import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';
import {IpRule} from '../../models/ip-rule';

@Injectable({
  providedIn: 'root'
})
export class IpRuleService extends AbstractModelService<IpRule> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/ip-rule', IpRule);
  }

  up(ipRule: IpRule): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<void>): void => {
      this.apiClient.post(this.routePath + '/' + ipRule.id + '/up').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  down(ipRule: IpRule): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<void>): void => {
      this.apiClient.post(this.routePath + '/' + ipRule.id + '/down').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
